/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dispatch } from 'react';

import { IListDefyReturn } from '../interfaces/defy';
import { DefyStatusManager } from '../services/manager';
import { getAllDefys, getDefyBySport, getDefyBySportPaginated } from '../services/defy';
import { listDefyActions } from './definition';

function defyError(e: string, commune: any) {
    return {
        type: listDefyActions.LIST_DEFY_ERROR,
        error: e,
        data: commune,
    };
}

// Reducers of Single Defy
function defyIsLoading() {
    return {
        type: listDefyActions.LIST_DEFY_IS_LOADING,
    };
}

const defyListReset = () => {
    return {
        type: listDefyActions.LIST_DEFY_RESET,
    };
};

// Recuders of Defy Collection
function defyIsLoadingList() {
    return {
        type: listDefyActions.LIST_DEFY_IS_LOADING,
    };
}

function defyErrorList(e: string) {
    return {
        type: listDefyActions.LIST_DEFY_ERROR,
        error: e,
    };
}

function defySetList(defys: any) {
    return {
        type: listDefyActions.LIST_DEFY,
        data: defys,
    };
}

/**
 * Reducer to rest a defys
 * @param values Data to reset defys
 */
export const resetStateDefy = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(defyListReset());
    };
};

/**
 * Reducer to rest a defys
 * @param values Data to reset defys
 */
export const resetDefyReset = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(defyListReset());
    };
};

/**
 * Reducer to reset Defys
 * @param values Values to reset defys
 */
export const resetDefy = () => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(defyListReset());
    };
};

// List

/**
 * Reducer to get all the defys
 */
export const fetchListDefys = (paginate = 1, limit = 999, search = '') => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(defyIsLoadingList());
        await getAllDefys(paginate, limit, search)
            .then((response: IListDefyReturn) => {
                if (response.statusCode === DefyStatusManager.CHALLENGES_LISTED) {
                    dispatch(defySetList(response.data));
                } else {
                    dispatch(defyErrorList(response.message));
                }
            })
            .catch((error) => {
                dispatch(defyErrorList(error));
            });
    };
};

/**
 * Reducer to get a defy by sport
 * @param query
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getDefyBysport = (query) => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(defyIsLoading());
        try {
            const response = await getDefyBySport(query);
            if (response?.statusCode === DefyStatusManager.CHALLENGES_LISTED && response.data) {
                dispatch(defySetList(response));
            } else {
                dispatch(defyError('Could not get defy: ', query.sport));
            }
        } catch (error: any) {
            const Err = {
                data: query,
                message: error,
                code: 'NOT_FOUNT',
            };
            dispatch(defyError('No se pudo obtener el defy', Err));
        }
    };
};

/**
 * Reducer to get a defy by sport paginated
 * @param query
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const getDefyBysportPaginated = (query) => {
    return async (dispatch: Dispatch<any>): Promise<void> => {
        dispatch(defyIsLoading());
        try {
            const response = await getDefyBySportPaginated(query);
            if (response?.statusCode === DefyStatusManager.CHALLENGES_LISTED && response.data) {
                // console.log('getDefyBysportPaginated', { response });
                let newData = response.data;
                newData = newData.map((item) => {
                    let newTeam = item;
                    if (item.team1 && item.team1.status === 'NOT_PAID') {
                        newTeam = {
                            ...newTeam,
                            team1: null,
                        };
                    }
                    if (item.team2 && item.team2.status === 'NOT_PAID') {
                        newTeam = {
                            ...newTeam,
                            team2: null,
                        };
                    }
                    return newTeam;
                });
                // console.log(newData);
                new dispatch(defySetList({ ...response, data: newData }));
            } else {
                dispatch(defyError('Could not get defy: ', query.sport));
            }
        } catch (error: any) {
            const Err = {
                data: query,
                message: error,
                code: 'NOT_FOUNT',
            };
            dispatch(defyError('No se pudo obtener el defy', Err));
        }
    };
};
